// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {"__root":{"price":{"f":""},"development_estimatedCompletion":{"b":""},"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function developmentProjectUnitType_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY") {
    return $$enum;
  }
}

let developmentProjectUnitType_fromString = developmentProjectUnitType_decode;

let Utils = {
  developmentProjectUnitType_decode: developmentProjectUnitType_decode,
  developmentProjectUnitType_fromString: developmentProjectUnitType_fromString
};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DevelopmentUnitSearchResult_newDevelopmentSampleUnit",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unitType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "args": [
            {
              "kind": "Literal",
              "name": "priceFormat",
              "value": "FULL"
            },
            {
              "kind": "Literal",
              "name": "priceRangeFormat",
              "value": "SHORT"
            }
          ],
          "kind": "FragmentSpread",
          "name": "PropertyPrice_propertyPrice"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DevelopmentProject",
      "kind": "LinkedField",
      "name": "development",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "developer",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "estimatedCompletion",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentUnitSearchResultCard_newDevelopmentSampleUnit"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentUnitSearchResultTitleAndLocation_newDevelopmentSampleUnit"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentUnitSearchResultAttributes_newDevelopmentSampleUnit"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentUnitSearchResultAgent_newDevelopmentSampleUnit"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentUnitSearchResultTimestamp_newDevelopmentSampleUnit"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentUnitSearchResultActions_newDevelopmentSampleUnit"
    }
  ],
  "type": "DevelopmentProjectSampleUnit",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
